import * as React from 'react';

import {Button} from 'shells/button/button';
import type {SubmittedField} from 'shells/form/view-submission-modal-content/view-submission-data';
import {ScrollableContainerWithShadow} from 'shells/layout/scrollable-container-with-shadow/scrollable-container-with-shadow';
import {Stack} from 'shells/layout/stack/stack';

import type {
    GetSubmission_submission_notificationLogs as SubmissionNotificationLog,
    SubmissionFragment_formVersion_form as Form,
} from 'nutshell-graphql-types';

import {TimelineBannerModalWrapper} from '../../timeline/banner/timeline-banner-modal-wrapper';

import {SubmissionData} from './submission-data';
import {SubmissionModalUrlSubHeader} from './submission-modal-url-sub-header';
import {SubmissionNotificationLogs} from './submission-notification-logs';

type ContentTab = 'submission' | 'notifications';

interface Props {
    onClose: () => void;
    submitter: any;
    form: Form;
    submissionTime: number;
    submittedFields: SubmittedField[];
    submissionUrl: string | null | undefined;
    notificationLogs: SubmissionNotificationLog[];
    isLoadingSubmission: boolean;
}

export function ViewFormSubmissionModal(props: Props) {
    const [selectedTab, setSelectedTab] = React.useState<ContentTab>('submission');

    let subtitleComponent = null;

    if (props.submissionUrl) {
        subtitleComponent = (
            // @ts-expect-error
            <SubmissionModalUrlSubHeader form={props.form} submissionUrl={props.submissionUrl} />
        );
    }

    const content =
        selectedTab === 'submission' ? (
            <SubmissionData
                submittedFields={props.submittedFields}
                isLoading={props.isLoadingSubmission}
            />
        ) : (
            <SubmissionNotificationLogs
                notificationLogs={props.notificationLogs}
                isLoading={props.isLoadingSubmission}
            />
        );

    return (
        <>
            <TimelineBannerModalWrapper
                onClose={props.onClose}
                iconVariant='form-submitted'
                timestamp={props.submissionTime}
                actor={props.submitter}
                entryType='Submission'
                changeType='FORM_SUBMISSION_MAPPED'
                entity={props.form}
                subtitleComponent={subtitleComponent}
            >
                <ScrollableContainerWithShadow
                    direction='vertical'
                    maxContainerSize={600}
                    showReverseGradientShadow={true}
                    gradientShadowSize={60}
                >
                    <div className='px-32 pb-32 pt-16'>
                        <Stack spacing={12}>
                            <Button
                                variant='text-primary'
                                size='small'
                                fitContent={true}
                                noPadding={true}
                                onClick={() =>
                                    setSelectedTab(
                                        selectedTab === 'submission'
                                            ? 'notifications'
                                            : 'submission'
                                    )
                                }
                            >
                                {selectedTab === 'submission'
                                    ? 'View notifications'
                                    : 'Back to submission'}
                            </Button>
                            {content}
                        </Stack>
                    </div>
                </ScrollableContainerWithShadow>
            </TimelineBannerModalWrapper>
        </>
    );
}
